import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import View from "../../../learning/presentational/body/view/View";
import Input from "./input/Input";
import NotEnteredAnswerPopup from "../../../learning/presentational/popup/NotEnteredAnswerPopup";
import LoadingPopup from "../../../learning/presentational/popup/LoadingPopup";
import ScribbleTooltip from "../../../learning/presentational/body/ScribbleTooltip";
import clsx from "clsx";

const Body = ( props ) => {

  const loading = useSelector( state => state.loading );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const questionView = useSelector( state => state.questionView );

  const {
    Viewer,
    Inputer,
    ScribbleTooltipHider,
    NotEnteredAnswerChecker,
    children,
    ...PROPS
  } = props;

  return (
    <div className="container">
      <div className="inner">
        <div className={
          clsx(
            "learningBox",
            (answeringQuestions.data.objctYn === 'Y') && 'multiple'
          )
        }>
          <Viewer><View { ...PROPS } /></Viewer>
          <Inputer><Input { ...PROPS } /></Inputer>
        </div>
        { answeringQuestions.isShowNotEnteredAnswerPopup && <NotEnteredAnswerChecker><NotEnteredAnswerPopup /></NotEnteredAnswerChecker> }
        { loading.isShowBall && <LoadingPopup /> }
      </div>
      { !! questionView.scribbleTooltipStatus && <ScribbleTooltipHider><ScribbleTooltip /></ScribbleTooltipHider> }
    </div>
  );

};

Body.defaultProps = {
  Viewer : Fragment,
  Inputer : Fragment,
  ScribbleTooltipHider : Fragment,
  NotEnteredAnswerChecker : Fragment
};

export default Body;
